import { render, staticRenderFns } from "./Masa.vue?vue&type=template&id=a5782e2e&scoped=true&"
import script from "./Masa.vue?vue&type=script&lang=js&"
export * from "./Masa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5782e2e",
  null
  
)

export default component.exports